export const CLIENT_TYPE_CONVERT_STORAGE_KEY = "rh.clientTypeConvert";

export interface ClientTypeConvertSession {
  prefill: Record<string, unknown>;
  targetType: string;
  archivedClientId: string;
  archivedClientSummary?: string;
}

export function readClientTypeConvertSession(): ClientTypeConvertSession | null {
  try {
    const raw = sessionStorage.getItem(CLIENT_TYPE_CONVERT_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as ClientTypeConvertSession;
  } catch {
    return null;
  }
}

export function writeClientTypeConvertSession(payload: ClientTypeConvertSession): void {
  try {
    sessionStorage.setItem(CLIENT_TYPE_CONVERT_STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* sessionStorage may be full / disabled - skip persistence */
  }
}

export function clearClientTypeConvertSession(): void {
  try {
    sessionStorage.removeItem(CLIENT_TYPE_CONVERT_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
